export const textUtil = () => {
  
  // 半角カタカナから全角カタカナへのマッピングテーブル
  const convertHalfKanaToFullKanaMap = {
    'ｳﾞ': 'ヴ', 'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
    'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
    'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
    'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
    'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
    'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
    'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
    'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
    'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
    'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
    'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
    'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
    'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
    'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
    'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
    'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
    'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ', 'ｯ': 'ッ',
    '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」',
    'ﾞ': '゛', 'ﾟ': '゜'
  };
  
  const convertHalfKanaToFullKana = (text) => {
    let convertedText = '';
    for (let i = 0; i < text.length; i++) {
      if (text[i] === 'ﾞ' || text[i] === 'ﾟ') {
        continue; // すでに前の文字で処理済みのためスキップ
      }
      const nextChar = text[i + 1];
      if (nextChar === 'ﾞ' || nextChar === 'ﾟ') {
        convertedText += applyDiacriticMark(text[i], nextChar);
        i++; // 次の文字（濁点/半濁点）をスキップ
      } else {
        convertedText += convertHalfKanaToFullKanaMap[text[i]] || text[i];
      }
    }
    return convertedText;
  }
  
  // 濁点・半濁点を処理するための関数
  const applyDiacriticMark = (char, nextChar) => {
    if (nextChar === 'ﾞ') {
      if (convertHalfKanaToFullKanaMap[char + nextChar]) {
        return convertHalfKanaToFullKanaMap[char + nextChar];
      }
      return String.fromCharCode(char.charCodeAt(0) + 1); // 濁点を加える
    } else if (nextChar === 'ﾟ') {
      if (convertHalfKanaToFullKanaMap[char + nextChar]) {
        return convertHalfKanaToFullKanaMap[char + nextChar];
      }
    }
    return convertHalfKanaToFullKanaMap[char] || char;
  };

  return {
    convertHalfKanaToFullKana
  }
}
